export const genderOptions = [
    'Masculino', 
    'Femenino', 
    'Otro'
];


export const yesNoOptions = [
    'Sí',
    'No'
];

export const fuelOptions = [
    'GasOil',
    'Nafta',
    'GNC',
    'Electricidad',
    'No uso auto'
];

export const plasticBagsOptions = {
    '30x40': 'Pequeña (30x40cm)',
    '40x50': 'Mediana (40x50cm)',
    '50x70': 'Grande (50x70cm o más)'
};

export const monthsOptions = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
];

export const optionsEnviormentalKnowledge=[
    'Sé poco y nada',
    'Sé algo y de vez en cuando busco aprender más',
    'Sé mucho y me preocupo',
    'Soy profesional en temas ambientales'
];
